(() => {
    var r = {},
        t = function r() {
            var t = document.querySelector(".js-recently-viewed-products");
            console.log(t, "recently view")
            document.querySelectorAll(".collection-recently-viewed .flickity-button");
            var e = JSON.parse(localStorage.getItem("recentProducts")),
                o = [],
                n = !1;
                console.log(e , "e -recently")
            if (t.hasAttribute("data-flickity") && (n = !0), e && (e.length > 6 && e.shift(), (o = e).length < 5 && t.classList.add("hide-arrows"), o.forEach(function(r, e) {
                    fetch(window.Shopify.routes.root + "products/".concat(r, "?view=card")).then(function(r) {
                        return r.text()
                    }).then(function(e) {
                        if (e.slice(0, 26).includes("product-card")) {
                            var c = t.querySelector(".flickity-slider");
                            c ? c.innerHTML += e : t.innerHTML += e, n && c && setTimeout(function() {
                                var r = Flickity.data(".js-recently-viewed-products");
                                r.reloadCells(), r.resize()
                            }, 1e3)
                        } else {
                            var i = o.indexOf(r);
                            i > -1 && o.splice(i, 1), localStorage.setItem("recentProducts", JSON.stringify(o))
                        }
                    }).catch(function(r) {
                        console.error("Error:", r)
                    })
                })), t.hasAttribute("data-product-handle")) {
                var i = t.getAttribute("data-product-handle");
                i && "" !== i.trim() && -1 === o.indexOf(i) && o.push(i), localStorage.setItem("recentProducts", JSON.stringify(o))
            }
            setTimeout(function() {
                c()
            }, 1e3)
        };

    function e(r, t, e) {
        var c = '<div class="product-colours">',
            o = [],
            n = [],
            i = Object.values(r.products);
        i.sort(function(r, t) {
            return parseInt(r.size) - parseInt(t.size)
        });
        for (var u = 0; u < i.length; u++) {
            var a = parseInt(i[u].id),
                s = i[u].colour,
                l = i[u].url,
                d = i[u].size,
                f = o.findIndex(function(r) {
                    return r.colour === s
                });
            if (a === t) var h = s; - 1 == f && o.push({
                colour: s,
                url: l,
                size: d
            }), n.push({
                id: a,
                colour: s,
                url: l,
                size: d
            })
        }
        o.forEach(function(r) {
            var t = "btn-colour-swatch " + r.colour.toLowerCase() + " h-6 w-6 rounded border border-gray-100 mr-2.5 cursor-pointer";
            t.includes(h) && (t += " current"), c += '<a href="' + r.url + '" class="' + t + '"></a>'
        }), c += "</div>", e.querySelector(".title").insertAdjacentHTML("afterend", c)
    }

    function c() {
        var r = document.querySelectorAll(".product-card-colours-container");
        r && r.forEach(function(r) {
            var t = r.getAttribute("data-colour-group"),
                c = parseInt(r.getAttribute("data-current-product-id"));
            if (t) {
                var o = new XMLHttpRequest;
                o.onreadystatechange = function() {
                    if (4 == this.readyState && 200 == this.status) {
                        var t = this.responseText;
                        if (t) try {
                            var o = JSON.parse(t)
                        } catch (n) {
                            var o = null
                        }
                        o && e(o, c, r)
                    }
                }, o.open("GET", "/collections/all/" + t + "?view=swatch", !0), o.send()
            }
        })
    }
    document.querySelector(".js-recently-viewed-products") && t()
})();